import Vue from 'vue'
import {
  FETCH_WINLOSE_RESULT_REQUEST,
  FETCH_WINLOSE_RESULT_SUCCESS,
  FETCH_WINLOSE_RESULT_ERROR,
  FETCH_GAME_RESULT_REQUEST,
  FETCH_GAME_RESULT_SUCCESS,
  FETCH_GAME_RESULT_ERROR,
  FETCH_WP_REQUEST,
  FETCH_WP_SUCCESS,
  FETCH_WP_ERROR,
} from '../actions/report'
import {
  BASE_URL,
  WINLOSE_RESULT,
  GET_GAME,
  M_POST,
  API_URL,
  WP
} from "../../utils/api"

const state = {
  status: "",
}

const actions = {
  [FETCH_WINLOSE_RESULT_REQUEST]: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      commit(FETCH_WINLOSE_RESULT_REQUEST)
      Vue.axios({ url: BASE_URL + WINLOSE_RESULT, data: data, method: M_POST })
        .then(resp => {
          let result = resp.data
          if (result.status.code === 0) {
            commit(FETCH_WINLOSE_RESULT_SUCCESS)
            resolve(result.data)
          } else {
            throw result.status
          }
        })
        .catch(err => {
          commit(FETCH_WINLOSE_RESULT_ERROR, err)
          reject(err)
        })
    })
  },
  [FETCH_GAME_RESULT_REQUEST]: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      commit(FETCH_GAME_RESULT_REQUEST)
      Vue.axios({ url: BASE_URL + GET_GAME, data: data, method: M_POST })
        .then(resp => {
          let result = resp.data
          if (result.status.code === 0) {
            commit(FETCH_GAME_RESULT_SUCCESS)
            resolve(result.data)
          } else {
            throw result.status
          }
        })
        .catch(err => {
          commit(FETCH_GAME_RESULT_ERROR, err)
          reject(err)
        })
    })
  },
  [FETCH_WP_REQUEST]: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      commit(FETCH_WP_REQUEST)
      Vue.axios({ url: API_URL + WP + `?wp=${data}`, data: data, method: M_POST })
        .then(resp => {
          let result = resp.data
          if (result.status.code === 0) {
            commit(FETCH_WP_SUCCESS)
            resolve(result.data)
          } else {
            throw result.status
          }
        })
        .catch(err => {
          commit(FETCH_WP_ERROR, err)
          reject(err)
        })
    })
  },
}

const mutations = {
  [FETCH_WINLOSE_RESULT_REQUEST]: state => {
    state.status = "loading"
  },
  [FETCH_WP_REQUEST]: state => {
    state.status = "loading"
  },
  [FETCH_WP_SUCCESS]: state => {
    state.status = "success"
  },
  [FETCH_WP_ERROR]: state => {
    state.status = "error"
  },
  [FETCH_WINLOSE_RESULT_SUCCESS]: state => {
    state.status = "success"
  },
  [FETCH_WINLOSE_RESULT_ERROR]: state => {
    state.status = "error"
  },
  [FETCH_GAME_RESULT_REQUEST]: state => {
    state.status = "loading"
  },
  [FETCH_GAME_RESULT_SUCCESS]: state => {
    state.status = "success"
  },
  [FETCH_GAME_RESULT_ERROR]: state => {
    state.status = "error"
  },
}

export default {
  state,
  actions,
  mutations
}
